import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  // NOTE: 卓につき1プラン。保存のたびに上書きされる
  updateExtensionPlan({ tableId, extensionPlan }) {
    return axiosIns.put(
      `/waiter/tables/${tableId}/extension_plan`,
      snakecaseKeys({ extensionPlan }),
    )
  },
  deleteExtensionPlan({ tableId }) {
    return axiosIns.delete(`/waiter/tables/${tableId}/extension_plan`)
  },
}
